import type { PropsWithChildren } from 'react';
import { createContext, useState } from 'react';

export const InsuranceStateContext = createContext<InsuranceStateContextType | null>(null);

export interface InsuranceState {
  isInsuranceSuccessModalActive: boolean;
}

export type InsuranceStateContextType = {
  insuranceState: InsuranceState;
  saveInsuranceState: (insuranceState: InsuranceState) => void;
};

const InsuranceStateProvider = ({ children }: PropsWithChildren<unknown>) => {
  const [insuranceState, setInsuranceState] = useState<InsuranceState>({
    isInsuranceSuccessModalActive: false,
  });
  const saveInsuranceState = (newInsuranceState: InsuranceState) => {
    setInsuranceState(newInsuranceState);
  };
  return (
    <InsuranceStateContext.Provider value={{ insuranceState, saveInsuranceState }}>
      {children}
    </InsuranceStateContext.Provider>
  );
};

export default InsuranceStateProvider;
